<h1 mat-dialog-title>Actividades</h1>
<div>
    <mat-tab-group>
        <mat-tab label="Estados facturación">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table style="width:100%" *ngIf="!loading" class="table-content">
                    <tr>
                        <th>Estado</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                    </tr>

                    <tr *ngFor="let log of invoicingStateLogs">
                        <td><div [innerHTML]="log.InvoicingStateName"></div></td>
                        <td>{{ log.User }}</td>
                        <td>{{ log.Date }}</td>
                    </tr>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Facturas">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table style="width:100%" *ngIf="!loading" class="table-content">
                    <tr>
                        <th>Factura</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                    </tr>

                    <tr *ngFor="let log of invoiceLogs">
                        <td>{{ log.InvoiceNumber }}</td>
                        <td>{{log.User}}</td>
                        <td>{{ log.Date }}</td>
                    </tr>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Validaciones">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loadingValidationLogs"></mat-spinner>
                <table style="width:100%" *ngIf="!loadingValidationLogs" class="table-content">
                    <tr>
                        <th class="cell-date">Fecha</th>
                        <th class="cell-date">Usuario</th>
                        <th>Respuesta validador</th>
                    </tr>

                    <tr *ngFor="let log of validationLogs">
                        <td class="cell-date">{{ log.Date }}</td>
                        <td class="cell-date">{{log.User}}</td>
                        <td>
                            <div style="width:100%; max-width:400px; word-wrap: break-word">{{log.Log}} </div>
                        </td>

                    </tr>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>
